import React from 'react'
import { Container, Row, Image, Card, Carousel, Button } from 'react-bootstrap';
import "./SleepConsultation.scss";

import {
  GROUP_SLEEP_CONSULT_URL,
  NEWBORN_SLEEP_CONSULT_URL,
  TODDLER_GROUP_SLEEP_CONSULT_URL
} from '../../../Utils/ServiceUrl';
import { useNavigate } from 'react-router-dom';
import { CONTACT, PODCASTQUESTION } from '../../../Routes/RouteConstent';
import LockScreen from "../../../Common/LockScreen/LockScreen";
import { getDataFromLocalStorage } from '../../../Service/getLocalStorage';
import AnyQuestion from '../../../Common/AnyQuestion/AnyQuestion';
import PodcastUI from '../../../Common/PodcastUi/PodcastUI';
import StreetCred from '../../../Common/streetCred/streetCred';
import LandingDescription from '../../../Common/LandingDescription';
import { HeroBanner }  from '../../../Common/HeroBanner';
import hero from '../../../Assets/img/service/sleep-consults-revert.png';
import newborn_consult_img from '../../../Assets/img/service/newborn-consult.png';
import baby_group from '../../../Assets/img/service/baby-group.png';
import toddler_group from '../../../Assets/img/service/toddler-group.png';

const SleepConsultation = () => {

  const Navigate = useNavigate()
  const userData = getDataFromLocalStorage()

  let testimonialData = [
    {
      name:"Kendall M.",
      data:"I used NAPS sleep consulting services for my third baby (I thought I was a sleep expert after my first two, I was wrong). My five month old was waking up every two hours, wouldn’t take naps longer than 30 minutes unless I was lying with him (not really an option with a 5 year old and 2 year old at home). Ellen was really encouraging and helpful. Her plan wasn’t easy, but really effective. After 2 nights baby was sleeping 11 hours straight and by day 4 he was taking 1+ hour naps. He is now a super sleeper and self soother and I feel like I have my sanity back. His wake times are also much more enjoyable and he’s an even happier little well rested baby. I am so happy I contacted NAPS!!"
    }

   
    // {
    //   name:"Shayna S.",
    //   data:"NAPS has been such a huge help in providing me a sense of comfort, confidence and community throughout all stages of my pregnancy and parenting journey. Emily and Jamie are the absolute best and offer such real and practical advice that I was able to implement and see changes right away.  Everything from breastfeeding, taking care of myself and getting my baby to sleep through the night in his crib. I've built such a great network of moms through MSG andt he starting solids workshop was wonderful. Make sure to check out their webinars too! Thank you NAPS!!"
    // }
  ]

  return (
    <div className='sleepConsultation'>
      <Container fluid>
        <div className="py-3">
          <HeroBanner
            hero={hero}
            title={
              <>
                <div  style={{color: '#30426D'}}>Let’s get you</div>
                <div  style={{color: '#30426D'}}>(and your child)</div>
                <div className="strong" style={{color: '#ffffff', fontWeight: '700'}}>
                some sleep!
                </div>
              </>
            }
          />
        </div>
        <LandingDescription
          ySpace
          content={[
            <>
              <span className="strong"> “You’ll never sleep again.”</span>
            </>,
            <>
              It’s one of the worst—and most untrue—pieces of advice parents hear. Sure, sleepless nights come with the territory when you have a newborn, baby, or even toddler. But the truth? You can sleep again—and we’re here to help make it happen.
            </>,
            <>
              If you’re caring for a newborn or young baby, we’ll teach you how to achieve longer stretches of sleep and work with your partner to create a manageable routine. As your baby grows into the toddler years, we’ll guide you in establishing solid bedtime and nap schedules to support healthy sleep habits.
            </>,
            <>
              Maybe sleep was going great, and now it’s not. That’s okay, too. Regression happens, but the good news is: we can help you get back on track as quickly as things went off the rails.
            </>,
          ]}
        />
        <Row className='pale-bg offering-main'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <Container>
              <Row className="justify-content-center my-5">
                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <div className="section-header text-center">
                    <h2 className="home-section-title py-0">Our sleep<span className="strong pink"> Offerings</span></h2>
                    <p className='mt-3'>NAPS offers age specific, group sleep consultations for children 0-3+ years old</p>
                  </div>
                </div>
              </Row>

              <Row className='justify-content-center align-items-center my-5'>
                <div className='col-lg-5 col-md-5 col-sm-12 order-1 order-md-0 mt-4 mt-md-0'>
                  <div className='offering-block-content offer-number1 me-0 me-md-5'>
                    <h3 className='lh-1 w-100 '>
                      <span className="offer-number">1. </span>
                      Newborn Group Sleep Consultation
                    </h3>
                    <p>For parents of babies 0-16 weeks who want to work on setting up a routine while home with their newborn and learn how to get longer stretches of sleep at night.</p>
                    <button className="w-auto btn-small teal-btn-small" onClick={() => Navigate(NEWBORN_SLEEP_CONSULT_URL)}>Book Now</button>
                  </div>
                </div>
                <div className='col-lg-5 col-md-5 col-sm-12 order-0 order-md-1'>
                  <div className='service-feature-img'>
                    <img src={newborn_consult_img} className='img-fluid' />
                  </div>
                </div>
              </Row>

              <Row className='justify-content-center align-items-center my-5'>
                <div className='col-lg-5 col-md-5 col-sm-12'>
                  <div className='service-feature-img me-0 me-md-5'>
                    <img src={baby_group} className='img-fluid' />
                  </div>
                </div>

                <div className='col-lg-5 col-md-5 col-sm-12 mt-4 mt-md-0'>
                  <div className='offering-block-content offer-number2'>
                    <h3 className='lh-1 w-100'>
                      <span className="offer-number">2. </span>
                      Baby Group Sleep Consultations
                    </h3>
                    <p>For parents of babies 4-18 months who want to work on bedtime, overnight sleep, daytime nap routines and to troubleshoot short naps or early morning wake-ups.</p>
                    <button className="w-auto btn-small purple-btn-small" onClick={() => Navigate(GROUP_SLEEP_CONSULT_URL)}>Book Now</button>
                  </div>
                </div>
              </Row>

              <Row className='justify-content-center align-items-center my-5'>
                <div className='col-lg-5 col-md-5 col-sm-12 order-1 order-md-0 mt-4 mt-md-0'>
                  <div className='offering-block-content offer-number1 me-0 me-md-5'>
                    <h3 className='lh-1 w-100 '>
                      <span className="offer-number">3. </span>
                      Toddler Group Sleep Consultation
                    </h3>
                    <p>For parents of toddlers aged 1.5 years to - 4 years who are navigating bedtime battles, overnight wake-ups, crib climbing or getting out of bed at night, transition to a toddler bed,short naps or nap refusal or seeking structure and consistency in scheduling and routines.</p>
                    <button className="w-auto btn-small teal-btn-small" onClick={() => Navigate(TODDLER_GROUP_SLEEP_CONSULT_URL)}>Book Now</button>
                  </div>
                </div>
                <div className='col-lg-5 col-md-5 col-sm-12 order-0 order-md-1'>
                  <div className='service-feature-img'>
                    <img src={toddler_group} className='img-fluid' />
                  </div>
                </div>
              </Row>


            </Container>
          </div>
        </Row>

        {(userData && !userData?.is_stripe_membership) &&
          <LockScreen />
        }

        <PodcastUI />

        <StreetCred data={testimonialData} />

        {/* <AnyQuestion /> */}
      </Container>
    </div>
  )
}

export default SleepConsultation;